import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkFileComponent } from '../../../link-file/link-file.component';
import { EditContractDataService } from '../../../../services/edit-contract-data.service';

@Component({
    selector: 'app-linked-files-tab',
    standalone: true,
    imports: [CommonModule, LinkFileComponent],
    template: `
        @if (contract()) {
            <app-link-file class="block h-full w-full" [document]="safeContract"></app-link-file>
        }
    `,
    styles: [`
        :host {
            display: block;
            height: 100%;
            width: 100%;
        }
    `]
})
export class LinkedFilesTabComponent {
    constructor(public dataService: EditContractDataService) { }

    // Use getter methods to access computed signals from the service - these will auto-update!
    get contract() { return this.dataService.contract; }

    // Helper getter that ensures we have a non-null contract
    get safeContract() {
        const c = this.contract();
        return c as any; // Type assertion to work around type narrowing limitation
    }
}

